
import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Switch } from '@/components/ui/switch';
import { Database } from 'lucide-react';

interface EmbeddingsTabContentProps {
  editing: boolean;
}

const EmbeddingsTabContent: React.FC<EmbeddingsTabContentProps> = ({ editing }) => {
  return (
    <div className="grid gap-4">
      <div className="grid gap-2">
        <Label htmlFor="embedding-model">Embedding Model</Label>
        <Select disabled={!editing} defaultValue="text-embedding-3-small">
          <SelectTrigger id="embedding-model">
            <SelectValue placeholder="Select a model" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="text-embedding-3-small">OpenAI Text Embedding 3 Small</SelectItem>
            <SelectItem value="text-embedding-3-large">OpenAI Text Embedding 3 Large</SelectItem>
            <SelectItem value="mxbai-embed-large">MXBai Embed Large</SelectItem>
            <SelectItem value="e5-large-v2">E5 Large v2</SelectItem>
          </SelectContent>
        </Select>
        <p className="text-xs text-muted-foreground">
          Used for semantic search and data retrieval
        </p>
      </div>
      
      <div className="flex items-center justify-between">
        <div className="space-y-0.5">
          <Label htmlFor="enable-rag">Enable RAG (Retrieval Augmented Generation)</Label>
          <p className="text-sm text-muted-foreground">Enhance AI responses with relevant contextual data</p>
        </div>
        <Switch 
          id="enable-rag" 
          checked={true} 
          disabled={!editing}
        />
      </div>
    </div>
  );
};

export default EmbeddingsTabContent;
